<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="owner">
            <pr-input-select-template
              formControlName="addressSituation"
              [options]="options"
            >
              <ng-template #optionTemplate let-option let-id="index">
                <div>
                  <div>
                    <residence-box
                      [suffix]="option.suffix"
                      [title]="option.label"
                      [svg]="option.svg"
                    ></residence-box>
                  </div>
                </div>
              </ng-template>
            </pr-input-select-template>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
